const cryptocurrency = {
  paymentMethodName: 'Criptomoeda',
  cryptocurrencyLabel: 'Criptomoeda',
  cryptocurrencySelectPlaceholder: 'Selecione sua criptomoeda',
  protocolWarning: 'Caso o pagamento seja feito em uma rede diferente da selecionada, o valor da transação pode ser perdido permanentemente. Por favor, <b>certifique-se de que sua carteira está configurada para a rede correta</b> antes de continuar.',
  networkLabel: 'Rede',
  networkSelectPlaceholder: 'Selecione sua rede',
  paymentButtonLabel: 'Pagar com Criptomoeda',
  amountLocal: 'Valor local',
  amountCrypto: 'Valor em crypto',
  paymentCreatedTitle: 'Seu pagamento foi criado!',
  paymentCreatedSubtitle: 'Não vai demorar muito até que seu pedido esteja completo! Siga as instruções abaixo para confirmar esta transação.',
  qrCodeInstruction: 'Escaneie o seguinte código QR em sua carteira para completar o pagamento em apenas alguns segundos.',
  qrCodeNetworkNotFound: 'Rede não encontrada. Certifique-se que selecionou a rede correta.',
  networkWarning: 'Você está pagando <b>{cryptocurrency}</b> usando <b>{protocol}</b>. Certifique-se de selecionar a rede correta em sua carteira, caso contrário, o valor da transação poderá ser perdido.',
  conversionRate: 'O valor convertido é 1 {currencyExt} = {formattedCryptoRate} {cryptocurrency}.',
  paymentApproved: 'Seu pagamento de <AmountText>{amountLocal}</AmountText> foi aprovado.',
  howToPayInfoTitle: 'Como pagar com criptomoeda?',
  howToPayOpenApp: 'Abra sua carteira (aplicativo ou extensão) e toque na opção Comprar, Transferir, Enviar ou Pagar.',
  howToPayQrCode: 'Escaneie o QR code e preencha os campos necessários usando copiar e colar.',
  howToPayNetwork: 'Certifique-se de selecionar a rede correta. Se a errada for escolhida, os fundos podem não ser recuperáveis.',
  howToPayConfirmation: 'Acompanhe o status na sua carteira (Atividade/Histórico) ou retorne a esta página para aguardar a confirmação.',
  payAgreement1: 'Ao continuar, você concorda com os ',
  serviceTerms: 'Termos e Condições',
  payAgreement2: ' do EBANX.',
  payWithWalletButton: 'Pagar com carteira cripto',
  walletRedirectInstruction: 'Você pode pagar clicando no botão e será redirecionado para concluir o pagamento.',
  manualQrCodeInstruction: 'Ou escaneie manualmente o QR Code abaixo para prosseguir com o pagamento',

};

module.exports = cryptocurrency;
